<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="30%" @close="resetField">
      <div slot="content">
        <el-form ref="form" :model="logGroupFormData" label-position="top" :rules="rules">
          <div v-show="checkType">
            <el-row>
              <el-form-item label="로그 그룹 아이디" prop="applogGroupId" label-width="120px"><el-input placeholder="그룹 아이디를 입력하세요" v-model="logGroupFormData.applogGroupId"></el-input></el-form-item>
            </el-row>
          </div>
          <el-row>
            <el-form-item label="로그 그룹명" prop="applogGroupName" label-width="120px"><el-input placeholder="그룹명을 입력하세요" v-model="logGroupFormData.applogGroupName"></el-input></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="정렬 순서" prop="orderbyIndex" label-width="120px"><el-input-number :min="1" v-model="logGroupFormData.orderbyIndex" controls-position="right"></el-input-number></el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <span v-show="checkType">
          <el-button size="large" type="solid" @click="addApplogGroup">저장</el-button>
        </span>
        <span v-show="!checkType">
          <el-button size="large" type="solid" @click="updateApplogGroup">저장</el-button>
        </span>
        <el-button  size="large" @click="close">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import ApplogSettingAPI from '@/api/settings/log/app-log-setting';
import msgUtil from '@/utils/message';

export default {
  name: 'WAppLogGroupPopup',
  components: {
    WSettingSlidingPopup,
  },
  data() {
    return {
      title: '로그 그룹 추가',
      checkType: true,
      rules: {
        applogGroupId: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        applogGroupName: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
    };
  },
  props: {
    type: {
      type: String,
    },
    logGroupFormData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    type() {
      if (this.type === 'Add') {
        this.checkType = true;
        this.title = '로그 그룹 추가';
      } else {
        this.checkType = false;
        this.title = '로그 그룹 수정';
      }
    },
    immediate: true,
  },
  methods: {
    /**
     * 로그 그룹 추가
     * @author leesy918
     */
    addApplogGroup() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          ApplogSettingAPI.addApplogGroup(this.logGroupFormData).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그 그룹', true));
              this.$emit('loadData');
              this.close();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '로그 그룹', false));
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그 그룹', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    /**
     * 로그 그룹 수정 적용
     * @author leesy918
     * @return {[type]} [description]
     */
    updateApplogGroup() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          ApplogSettingAPI.updateApplogGroup(this.logGroupFormData).then((response) => {
            if (response.data.success) {
              // 응답 데이터 처리
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그 그룹', true));
              this.$emit('loadData');
              this.close();
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그 그룹', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    open() {
      this.$refs.slidingPopup.open();
    },
    resetField() {
      this.$refs.form.resetFields();
    },
    close() {
      this.$refs.form.resetFields();
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Applog/popup/AppLogGroupPopup.vue